const $ = jQuery;

class SocialShare {
	init() {
		$(document).on('click', '[data-social-share]', this.sharePopup);
	}

	sharePopup(e) {
		e.preventDefault();

		const intWidth = '500';
		const intHeight = '400';
		const strResize = 'yes';
		const strTitle =
			typeof $(this).attr('title') !== 'undefined' ? $(this).attr('title') : 'Social Share';
		const strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;

		window.open($(this).attr('href'), strTitle, strParam).focus();
	}
}

export default new SocialShare();
